// Generated by `pnpm --filter @corca/data build-libraries`. Do not edit.
export { LIBRARY_KEYS, type LibraryKey } from "./keys";

export const PACK_LOCALES = ["de", "es", "fr", "hi", "id", "ja", "pl", "pt", "ru", "zh"] as const;

export type PackLocale = (typeof PACK_LOCALES)[number];

const packLoaders = {
  de: () => import("./packs/de"),
  es: () => import("./packs/es"),
  fr: () => import("./packs/fr"),
  hi: () => import("./packs/hi"),
  id: () => import("./packs/id"),
  ja: () => import("./packs/ja"),
  pl: () => import("./packs/pl"),
  pt: () => import("./packs/pt"),
  ru: () => import("./packs/ru"),
  zh: () => import("./packs/zh"),
};

/**
 * The whole core set, loaded on first call as one chunk.
 */
export const loadLibraries = () => import("./all").then((module) => module.libraries);

/**
 * One locale's translation packs by library key, loaded on first call as one chunk.
 */
export const loadPacks = (locale: PackLocale) =>
  packLoaders[locale]().then((module) => module.packs);
